import { Fragment, h } from 'preact';
import { useContext } from 'preact/hooks';
import Unread from 'widget_main/components/Unread';
import ChatIcon from 'widget_main/components/ChatIcon';
import classNames from 'classnames';
import { NavigationContext, ProactiveChatContext } from 'widget_main/store';
import { MESSAGE_THREAD_PATH } from 'widget_main/globals/constants';
import { getChatIconFrameSize } from 'helpers/kustomer_api_iframe';
import styles from './chatRootIcon.scss';
import ProactivePopup from '../ProactivePopup/ProactivePopup';

interface ChatRootIconProps {
  onClick?: () => void;
  isMobile: boolean;
}

const ChatRootIcon = ({ onClick, isMobile }: ChatRootIconProps) => {
  const { proactiveChat, onCloseProactiveChat } =
    useContext(ProactiveChatContext);
  const navigation = useContext(NavigationContext);

  const handleChatIconClick = () => {
    if (proactiveChat) {
      navigation.updateInitAssistantPayload(proactiveChat.initResponse);
      navigation.updateCurrentConversationId(undefined);
      navigation.updatePage(MESSAGE_THREAD_PATH);
      onCloseProactiveChat();
    }
    if (onClick) onClick();
  };
  const renderProactiveChat = () => {
    return proactiveChat ? <ProactivePopup isMobile={isMobile} /> : null;
  };
  const chatIconFrameSize = getChatIconFrameSize();
  return (
    <Fragment>
      {renderProactiveChat()}
      <div
        className={classNames(
          {
            [styles.proactivePopupActive]: proactiveChat,
          },
          styles.chatIconWrapper,
        )}
        style={{
          width: chatIconFrameSize.width,
          height: chatIconFrameSize.height,
        }}
      >
        <ChatIcon isEmbedIcon onClick={handleChatIconClick} />
        <Unread className={styles.unreadProp} />
      </div>
    </Fragment>
  );
};
export default ChatRootIcon;
